const BaseModal = require("components/modals/BaseModal");
const PropTypes = require("prop-types");
const assign = require("object-assign");
const {classList} = require("helpers/html");

class Modal extends BaseModal {

	static get propTypes() {
		return assign(super.propTypes, {
			title: PropTypes.any,
		});
	}

	get baseClassName() {
		return classList(
			super.baseClassName,
			"text-modal"
		);
	}

	onCloseClick = e => {
		e.preventDefault();
		e.stopPropagation();

		this.close();
	};

    renderHeader() {
        if (!this.props.title) return;

        return (
            <div className="top-bar border-bottom">
                <p className="title">{this.props.title}</p>
            </div>
        );
    }

}

module.exports = Modal;

